<template>
  <div class="our-beliefs-intro-content" id="plataforma-de-marca-nossas-crencas-introducao" data-search-anchor>
    <div class="description-our-beliefs-intro-content">
      <h1 class="our-beliefs-intro-description">{{ introDescription }}</h1>
    </div>

    <div class="our-beliefs-intro-card-item" :style="{ backgroundImage: `url(${introImageSrc})` }"></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import OurBeliefsPageMixin from '@/mixins/our-beliefs-page-mixin'
import { OurBeliefsPageStore } from '@/store/brand-plataform-page/our-beliefs-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class OurBeliefsIntroSection extends Mixins(OurBeliefsPageMixin) {
  ourBeliefsPageStore: PageStoreContract = getModule(OurBeliefsPageStore, this.$store)

  get introDescription(): string {
    return this.getElementText(1, 0)
  }

  get introImageSrc(): string {
    return this.getElementMedia(1, 0)
  }

  async getOurBeliefsPage(): Promise<void> {
    await this.ourBeliefsPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.ourBeliefsPageStore.isLoading) {
      await this.getOurBeliefsPage()
    }
  }
}
</script>

<style lang="scss">
.our-beliefs-intro-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px; 
}

.description-our-beliefs-intro-content {
  font-size: 70px;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: -.01em;
  text-align: left;
  margin-top: 1rem;
  padding-right: 52px;
}

.our-beliefs-intro-description {
  font-size: 56px;
  font-weight: 400;
  line-height: 54px;
  letter-spacing: -0.01em;
  text-align: left;
  margin: 0;
}

.our-beliefs-intro-card-item {
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;  
  background-repeat: no-repeat;
  background-position: center;  
}
</style>
